// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__24QTq","avatar":"style_avatar__2jHjz"};